import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import {init} from '../../auth/handleTokens';
import useAuth from '../../auth/useAuth';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const MyMessages = (props) => {
    const toggle = props.toggleSidebar ? '215px' : '10px'
    const [myMessage, setMyMessage] = useState("");
    const [myMessages, setMyMessages] = useState([]);
    const [creditsCount, setCreditsCount] = useState(0);
    const [newMessage, setNewMessage] = useState(false);
    const {user} = useAuth();
    const [charactersCount, setCharactersCount] = useState(user.organization.length);

    const {showNotification} = useContext(NotificationContext);

    const tableMessages = myMessages.map((item, index) =>
      <tr key={item._id}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'justify'}}>{item.content}</td>
        <td title='Número de caracteres' style={{textAlign: 'justify'}}>{item.characters}</td>
        <td title='Número de créditos' style={{textAlign: 'justify'}}>{item.credits}</td>
        <td style={{textAlign: 'justify'}}>{item.dateRequest}</td>
        <td style={{textAlign: 'justify'}}>{item.state}</td>
        <td id={item._id} style={{textAlign: 'justify'}}> <a title='Eliminar solicitud' className='btn-sm btn btn-primary' onClick={(e) => selectionMessage(e.target)}><i className="fas fa-trash-alt"></i></a></td>
      </tr>
    )


    useEffect(() => {
      getMyMessages();
    },[newMessage])

    useEffect(() => {
      const value = charactersCount / 159
      setCreditsCount(Math.ceil(value));
    }, [charactersCount])


    const writeMessage = (value) => {
      setMyMessage(value)
      setCharactersCount(user.organization.length + value.length)
    }
    
    const selectionMessage = (e) => {
      deletePendingMessages(e.offsetParent.id);
     }

    const deletePendingMessages = async(idMessage) => {
      const result = await init();
      if(!result) return window.location.href = '/login';
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/sms/delete-pending-message/' + idMessage;
      await axios.delete(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
      .then(({data}) => {
        showNotification('success', data.message);
        setNewMessage(!newMessage);
      })
      .catch((error) => {
        console.log(error);
        showNotification('failed', error.response.data.message)
      })
    }

    const refreshMessage = () => {
      setNewMessage(!newMessage);
    }

    const sendRequest = async() => {
      if(charactersCount===0) return showNotification('failed', 'El campo de mensaje no puede estar vacío!')
      const result = await init();
      if(!result) return window.location.href = '/login';
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/sms/create-pending-message';
      await axios.post(URL,{content: user.organization + ' ' + myMessage, charactersCount, creditsCount}, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
      .then(({data}) => {
        showNotification('success', data.message);
        setMyMessage('');
        setNewMessage(!newMessage);
        setCharactersCount(user.organization.length);
      })
      .catch(error => showNotification('failed', error.response.data.message));
    }
    

    const getMyMessages =  async() => {
      try {
        const result = await init();
        if(!result) return window.location.href = '/login';
        const token = window.localStorage.getItem('at');
        const URL = constants.test_host + '/sms/get-pending-messages';
        const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
        setMyMessages(data.pendingMessages);
        
       } catch (error) {
          console.log(error)
       }
    }

  return (
    <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s",  paddingLeft: '20px'}} >
      <div className='container'>
      <h5 className='subtitle'>Solicitud de Mensajes</h5>
      <form className="row g-2">
            <div style={{fontSize: 'medium'}} className="col-auto form-floating form-outline">
              
              <textarea
                type="text"
                className="form-control"
                id="message"
                name='message'
                required
                value={myMessage}
                onChange= {({target}) => writeMessage(target.value)}
                placeholder= 'Escribe aquí tu mensaje...'
                style={{fontSize:'0.8rem', minWidth: '60vw'}}
              />
              <label style={{fontSize: 'small'}} htmlFor="nameLink">
                Escribe aquí tu mensaje...
              </label>
              
              <p style={{fontSize: '0.8rem'}}>Caracteres: <span data-bs-toggle="popover" data-bs-trigger="hover focus" data-bs-content="Disabled popover">{charactersCount}</span> - Créditos: <span>{creditsCount}</span></p>
              <div>
              <button type='button' onClick={sendRequest} className="btn btn-sm btn-primary mb-3">
                Solicitar
              </button>
                <p style={{fontSize: '0.8rem', borderStyle:'solid', borderWidth:'1px', borderColor: 'rgb(187, 200, 219)'}}>El número de caracteres inicia en {user.organization.length} dado que el nombre de tu negocio irá al inicio de tu mensaje.</p>
                <p style={{fontSize: '0.8rem', borderStyle:'solid', borderWidth:'1px', borderColor: 'rgb(187, 200, 219)'}}>El mensaje solicitado será revisado para su aprobación en las próximas 24 horas, una vez aprobado podrá ser enviado a sus clientes desde la opción "Mensajes aprobados".</p>
                
              </div>
            </div>
        
          </form>

          <hr />

          <div>
          <h6 style={{textAlign: 'left', paddingLeft:'20px', fontSize:'smaller'}}>Mensaje sin aprobar: <button onClick={() => refreshMessage()} title='Refrescar' className='btn btn-sm btn-primary'><i className="fas fa-sync-alt"></i></button></h6>
          <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
            <thead>
              <tr>
                <th>#Id</th>
                <th>Mensaje</th>
                <th title='Número de caracteres'>Caract</th>
                <th title='Número de créditos'>Cred</th>
                <th>Fecha de Solicitud</th>
                <th>Estado</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {tableMessages}
            </tbody>
          </table>
        </div>

      </div>
      
    </div>
  )
}

export default MyMessages